import { InternalApiScreeningFlow, InternalApiScreeningListType } from '../../api-internal';
import { ScreenableFieldSetupProps } from './helpers/useScreenableFieldSetupContextManager';
import { ApiSanctionType } from '../../api';

export const getScreeningListType = (type: ApiSanctionType): InternalApiScreeningListType => {
  switch (type) {
    case ApiSanctionType.SANCTION:
      return InternalApiScreeningListType.SANCTION;
    case ApiSanctionType.PEP:
      return InternalApiScreeningListType.PEP;
    case ApiSanctionType.ADVERSE_MEDIA:
      return InternalApiScreeningListType.ADVERSE_MEDIA;
    case ApiSanctionType.ADVERSE_MEDIA_ENTITY:
      return InternalApiScreeningListType.ADVERSE_MEDIA_ENTITY;
    case ApiSanctionType.CUSTOM_SCREENING_LIST:
      return InternalApiScreeningListType.CUSTOM_LIST;
  }
};

export const getDjListName = (type: ApiSanctionType): string | undefined => {
  switch (type) {
    case ApiSanctionType.SANCTION:
      return 'Dow Jones Sanctions';
    case ApiSanctionType.PEP:
      return 'Dow Jones PEP';
    case ApiSanctionType.ADVERSE_MEDIA:
      return 'Dow Jones Adverse Media';
    case ApiSanctionType.ADVERSE_MEDIA_ENTITY:
      return 'Dow Jones AME';
    default:
      return undefined;
  }
};

export const getFlow = (setupContext: ScreenableFieldSetupProps): InternalApiScreeningFlow => {
  return {
    id: setupContext.flowId,
    entityType: setupContext.entityType,
    field: setupContext.usableFields.map(({ fieldName }) => fieldName).join(' '),
    goodList: {
      key1: setupContext.goodlistIdentifiers.goodlistKey1,
      key2: setupContext.goodlistIdentifiers.goodlistKey2,
      key3: setupContext.goodlistIdentifiers.goodlistKey3,
    },
    includedSegments: setupContext.includedSegments,
    excludedSegments: setupContext.excludedSegments,
    match: {
      type: setupContext.matchType.type,
      value: setupContext.matchType.value ?? undefined,
    },
    lists: [
      ...setupContext.dowJonesListTypes.map((type) => ({
        type: getScreeningListType(type),
        list: {
          name: getDjListName(type),
        },
        selectorGroupCodes: type === ApiSanctionType.SANCTION ? setupContext.selectorGroupCodes : undefined,
      })),
      ...setupContext.customListConfiguration
        .map(({ list, fields }) =>
          fields.map((field) => ({
            type: InternalApiScreeningListType.CUSTOM_LIST,
            list: {
              id: list.id,
              name: list.name,
            },
            usableField: {
              id: field.id,
              name: field.name,
            },
          }))
        )
        .flat(),
    ],
  } as InternalApiScreeningFlow;
};
